module.exports = __webpack_public_path__ + "img/33bb86b.jpg";